const keyboardDatePickerFormActions = {
  deadline: 'Prazo'
};

export default keyboardDatePickerFormActions;
